<div class="flex-fill d-flex flex-column" *ngIf="quickbooks">
    <div class="btn-toolbar mx-3 mb-0 mt-3">
        <button type="button" (click)="connect()" class="btn btn-primary me-2" [disabled]="!quickbooks || quickbooks.status === 'Connected'">Connect</button>
        <button type="button" (click)="disconnect()" class="btn btn-danger me-2" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Disconnect</button>
        <button type="button" (click)="checkStatus()" class="btn btn-primary me-2" [disabled]="!quickbooks">Check Status</button>
    </div>
    <div class="grid-fill m-3">
        <dx-form [formData]="quickbooks" *ngIf="quickbooks">
            <dxi-item itemType="group" caption="Quickbooks Information">
                <dxi-item dataField="status" [label]="{ text: 'Status' }" [disabled]="true" [editorOptions]="{readOnly: true, width: '200px'}"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Quickbooks Actions">
                <dxi-item>
                    <button type="button" (click)="startDealerExport()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Export Dealers</button>
                </dxi-item>
                <dxi-item>
                    <button type="button" (click)="startVendorExport()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Export Vendors</button>
                </dxi-item>
                <dxi-item>
                    <button type="button" (click)="startPurchaseExport()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Export Vendor Bills</button>
                </dxi-item>
                <dxi-item>
                    <button type="button" (click)="startExportInvoices()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Export Invoices</button>
                </dxi-item>
                <dxi-item>
                </dxi-item>
                <dxi-item>
                    <button type="button" (click)="syncDealerIds()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Sync Dealer Ids</button>
                </dxi-item>
                <dxi-item>
                    <button type="button" (click)="syncVendorIds()" class="btn btn-primary mt-3" [disabled]="!quickbooks || quickbooks.status !== 'Connected'">Sync Vendor Ids</button>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</div>
